module.exports = __webpack_public_path__ + "img/woman.022caab6.jpg";